// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-6f16b75d] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-6f16b75d] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-6f16b75d] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-6f16b75d] {
  margin-bottom: 3px;
  font-size: 11px;
  white-space: initial;
}
.min-120[data-v-6f16b75d] {
  min-height: 80px;
}
.brake_word span[data-v-6f16b75d] {
  word-break: break-word;
  display: inline-block;
}
.my_current_vehicle .car_info[data-v-6f16b75d] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.my_current_vehicle .car_info img[data-v-6f16b75d] {
  height: 60px;
  margin: auto;
  display: block;
  object-fit: contain;
}
.my_current_vehicle .car_info h5[data-v-6f16b75d] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.my_current_vehicle .car_info p[data-v-6f16b75d] {
  margin-bottom: 3px;
  font-size: 11px;
  white-space: initial;
}
.car_icon i[data-v-6f16b75d] {
  font-size: 30px;
  opacity: 0.6;
}
.animate_bottom[data-v-6f16b75d] {
  animation: animateBottom-6f16b75d 2s;
  transition: 0.5s;
}
@keyframes animateBottom-6f16b75d {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.my_current_vehicle .car_info h5[data-v-6f16b75d] {
    font-size: 13px;
}
.my_current_vehicle .car_info p[data-v-6f16b75d] {
    font-size: 12px;
}
.custom_legend[data-v-6f16b75d] {
    font-size: 13px;
}
}
@media (min-width: 2500px) {
.my_current_vehicle .car_info h5[data-v-6f16b75d] {
    font-size: 16px;
}
.my_current_vehicle .car_info p[data-v-6f16b75d] {
    font-size: 14px;
}
.custom_legend[data-v-6f16b75d] {
    font-size: 16px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmUpgradeVehicle/TvmUpgradeVehicle.vue","webpack://./TvmUpgradeVehicle.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACFF;ADKA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACJJ;ADFA;EAUI,kBAAA;EACA,eAAA;EACA,oBAAA;ACLJ;ADSA;EACE,gBAAA;ACPF;ADUA;EACE,sBAAA;EACA,qBAAA;ACRF;ADYA;EA5CE,sBAAA;EACA,mBAAA;EACA,YAAA;ACmCF;ADOA;EAKM,YAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;ACTN;ADCA;EAxBI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;AC0BJ;ADNA;EAhBI,kBAAA;EACA,eAAA;EACA,oBAAA;ACyBJ;ADIA;EACE,eAAA;EACA,YAAA;ACFF;ADKA;EACE,oCAAA;EACA,gBAAA;ACHF;ADMA;AACE;IACE,2BAAA;ACJF;ADOA;IACE,wBAAA;ACLF;AACF;ADQA;AACE;IAEI,eAAA;ACPJ;ADKA;IAMI,eAAA;ACRJ;ADYA;IACE,eAAA;ACVF;AACF;ADaA;AACE;IAEI,eAAA;ACZJ;ADUA;IAMI,eAAA;ACbJ;ADiBA;IACE,eAAA;ACfF;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n\n.card_font_sizes {\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n\n  p {\n    margin-bottom: 3px;\n    font-size: 11px;\n    white-space: initial;\n  }\n}\n\n.min-120 {\n  min-height: 80px;\n}\n\n.brake_word span {\n  word-break: break-word;\n  display: inline-block;\n}\n\n// end reuseable css\n.my_current_vehicle {\n  .car_info {\n    .value_your_trade_card();\n\n    img {\n      height: 60px;\n      margin: auto;\n      display: block;\n      object-fit: contain;\n    }\n\n    .card_font_sizes();\n  }\n}\n\n.car_icon i {\n  font-size: 30px;\n  opacity: 0.6;\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 1900px) {\n  .my_current_vehicle .car_info {\n    h5 {\n      font-size: 13px;\n    }\n\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 2500px) {\n  .my_current_vehicle .car_info {\n    h5 {\n      font-size: 16px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 16px;\n  }\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 3px;\n  font-size: 11px;\n  white-space: initial;\n}\n.min-120 {\n  min-height: 80px;\n}\n.brake_word span {\n  word-break: break-word;\n  display: inline-block;\n}\n.my_current_vehicle .car_info {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.my_current_vehicle .car_info img {\n  height: 60px;\n  margin: auto;\n  display: block;\n  object-fit: contain;\n}\n.my_current_vehicle .car_info h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.my_current_vehicle .car_info p {\n  margin-bottom: 3px;\n  font-size: 11px;\n  white-space: initial;\n}\n.car_icon i {\n  font-size: 30px;\n  opacity: 0.6;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .my_current_vehicle .car_info h5 {\n    font-size: 13px;\n  }\n  .my_current_vehicle .car_info p {\n    font-size: 12px;\n  }\n  .custom_legend {\n    font-size: 13px;\n  }\n}\n@media (min-width: 2500px) {\n  .my_current_vehicle .car_info h5 {\n    font-size: 16px;\n  }\n  .my_current_vehicle .car_info p {\n    font-size: 14px;\n  }\n  .custom_legend {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
